export const setChannelHighlightedRow = (state, action) => {
  state.channelHighlightedRow = action.payload
}
